import makeApiClient, { Type } from '@/features/api'
import { z } from 'zod'
import { assertSchema } from '@/helpers/assert-schema'

type Argument = {
  organisationId: number
}

export type UserList = z.infer<typeof schema>

const apiSchema = z.array(
  z.object({
    id: z.string(),
    firstName: z.string(),
    lastName: z.string(),
    emailAddress: z.string(),
    permissions: z.array(z.string())
  })
)

export const schema = z.array(
  apiSchema.element.extend({ name: z.string() })
)

const { sendGetRequest } = makeApiClient(Type.Core)

export default async function getUserList({ organisationId } : Argument): Promise<UserList> {
  const { data } = await sendGetRequest(`users?organisation=${organisationId}`)

  assertSchema(data, apiSchema)

  return data.map(
    x => ({
      ...x,
      name: `${x.firstName} ${x.lastName}`.trim()
    })
  )
}
